(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["purelyte-comparison-cells"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.PurelyteComparisonCells) return;

  function fmtMg(v, source, mineral, note) {
    if (!v) return '<span class="plyt-sbs__cell-val plyt-sbs__no">—</span>';
    var html = '<span class="plyt-sbs__cell-val">' + v + " mg</span>";
    if (source) {
      // Mineral-scoped key (e.g. magnesium-citrate) so a form can mean
      // something different per mineral — magnesium citrate's laxative effect
      // doesn't apply to potassium or calcium citrate. The glossary falls back
      // to the plain form when there's no mineral-specific entry.
      // Spaces become dashes, matching Liquid's handleize, so a multi-word
      // source like "Pink Himalayan Salt" finds its "pink-himalayan-salt" entry.
      var key = (mineral ? mineral + "-" : "") + source.toLowerCase().trim().replace(/\s+/g, "-");
      html += '<span class="plyt-sbs__cell-sub">from ' + source;
      // Emit the trigger unconditionally. This used to check
      // window.PurelyteSaltGlossary first, which lost the race whenever
      // Shopify happened to bundle this block's JS ahead of the glossary
      // snippet's — the "?" markup was simply never written on first render,
      // and only appeared once a filter change forced a re-render. Unknown
      // terms are pruned by wireTermTriggers instead, so nothing dead is left.
      html += ' <span class="plyt-term__wrap"><button class="plyt-term__trigger" type="button" data-term="' + key + '" aria-expanded="false">?</button></span>';
      html += "</span>";
    }
    if (note) html += '<span class="plyt-sbs__cell-sub">' + note + "</span>";
    return html;
  }

  function fmtBool(v) {
    return v ? '<span class="plyt-sbs__yes">Yes</span>' : '<span class="plyt-sbs__no">No</span>';
  }

  // The row counts sugar AND high-GI carbs in one figure, so a brand whose
  // grams are carbohydrate rather than sugar can say where they come from.
  // Same treatment as the minerals' "from Chloride" line directly above.
  function fmtSugar(b) {
    var html = '<span class="plyt-sbs__cell-val">' + b.sugar + "g</span>";
    // Inline after the figure — "0.3g (Raspberry)" — rather than the block
    // sub-line the minerals use, because it qualifies the number itself rather
    // than explaining it. It drops to its own line on a phone, where the
    // column is too narrow to carry both.
    if (b.sugarNote) html += ' <span class="plyt-sbs__note-inline">' + b.sugarNote + "</span>";
    return html;
  }

  // One span per value, so a phone can put each on its own line. Cells are
  // white-space: nowrap to keep the numbers aligned, which means a run like
  // "Glucose, Sucralose" would otherwise force the column wider instead of
  // wrapping. Desktop restores the commas in CSS and reads as one line.
  function fmtList(v) {
    var s = (v || "").trim();
    if (!s) return '<span class="plyt-sbs__no">—</span>';
    var parts = s.split(/[;,]/).map(function (p) { return p.trim(); }).filter(Boolean);
    if (parts.length < 2) return '<span class="plyt-sbs__cell-val">' + s + "</span>";
    // The wrapper is what opts the run out of the cell's nowrap and caps its
    // width, so a three-item list wraps inside the column on desktop instead
    // of stretching it.
    return '<span class="plyt-sbs__wrap">' + parts.map(function (p) {
      return '<span class="plyt-sbs__cell-val plyt-sbs__item">' + p + "</span>";
    }).join("") + "</span>";
  }

  // Three distinct states, and the difference between the last two matters:
  //   blank  -> "—", meaning not checked. Never rendered as "None", which
  //             would assert something about a competitor we haven't verified.
  //   "None" -> stated plainly, no flag styling.
  //   other  -> flagged, since the entry is a list of what was found.
  // Four states, because a blank label is not a denial. Anything unrecognised
  // (including a legacy true/false from when this was a checkbox) falls to
  // Undeclared — the only safe default, since it asserts nothing.
  // "Likely" is its own state and deliberately not folded into "Yes". A natural
  // flavour, a coconut water powder or a bare "Flavour" excipient is very often
  // carried on maltodextrin, but the label doesn't say so — publishing a flat
  // Yes would assert something about a competitor's formula that their own
  // label doesn't support. The note underneath says why.
  function fmtMaltodextrin(v, note) {
    var sub = note ? '<span class="plyt-sbs__cell-sub">' + note + "</span>" : "";
    switch (String(v == null ? "" : v).toLowerCase()) {
      case "yes":
        return '<span class="plyt-sbs__cell-val">Yes</span>' + sub;
      case "yes-flavour":
        // Declared, but only on the flavoured variants — the unflavoured
        // version of the same product carries none.
        return '<span class="plyt-sbs__cell-val">Yes</span>' +
          '<span class="plyt-sbs__cell-sub">flavoured variants only</span>' + sub;
      case "yes-assumed":
        return '<span class="plyt-sbs__cell-val">Likely</span>' + sub;
      case "no":
        return '<span class="plyt-sbs__cell-val">No</span>' + sub;
      default:
        return '<span class="plyt-sbs__no">Undeclared</span>' + sub;
    }
  }

  // Water volume the serve is mixed into. 0 / missing renders as a dash
  // rather than "0ml", which would read as a claim.
  function fmtServe(v) {
    var n = Number(v) || 0;
    if (!n) return '<span class="plyt-sbs__no">—</span>';
    return '<span class="plyt-sbs__cell-val">' + n + " ml</span>";
  }

  // Derived from price per serve and serve size rather than stored, so the
  // three price rows always agree and a reader can check the arithmetic.
  // 0 means it can't be worked out (no serve size), not "free".
  function perLitreValue(b) {
    var ml = Number(b.serveSizeMl) || 0;
    var pps = Number(b.pricePerServe) || 0;
    return ml && pps ? pps * 1000 / ml : 0;
  }

  function fmtPerLitre(b) {
    var v = perLitreValue(b);
    if (!v) return '<span class="plyt-sbs__no">—</span>';
    return '<span class="plyt-sbs__cell-val">$' + v.toFixed(2) + "</span>";
  }

  // "Flavour(s) not declared natural or artificial" and "Colour not declared
  // natural or artificial" are gaps in what the brand published, not
  // ingredients we found — they get a quiet footnote rather than a flag chip,
  // so the chips only ever carry things actually named on a label. Anchored at
  // the start so "Artificial Flavour (unspecified)", which IS a declared
  // artificial ingredient, still reads as one.
  var DISCLOSURE_GAP = /^(flavou?r|colou?r)\b[^;]*\b(not declared|not disclosed)\b/i;

  // A stronger gap than the one above: the brand publishes no ingredient list
  // at all. It has to suppress "None identified", which would otherwise read as
  // a finding — nothing was identified because there was nothing to read, not
  // because the label is clear.
  var NO_LIST = /\bingredient list\b/i;

  function fmtArtificial(v) {
    var s = (v || "").trim();
    if (!s) return '<span class="plyt-sbs__no">—</span>';
    if (s.toLowerCase() === "none") return '<span class="plyt-sbs__cell-val">None</span>';

    var named = [];
    var gaps = [];
    var noList = false;
    s.split(/[;,]/).forEach(function (part) {
      var p = part.trim();
      if (!p) return;
      if (NO_LIST.test(p)) { noList = true; gaps.push(p); return; }
      (DISCLOSURE_GAP.test(p) ? gaps : named).push(p);
    });

    var html = named.length
      ? named.map(function (p) { return '<span class="plyt-sbs__flag">' + p + "</span>"; }).join("")
      : (noList ? "" : '<span class="plyt-sbs__cell-val">None identified</span>');
    // One span per gap rather than a joined string — cell-sub is display:block,
    // so the flavour note and the colour note each get their own line instead
    // of running past the column edge.
    html += gaps.map(function (g) {
      return '<span class="plyt-sbs__cell-sub">' + g + "</span>";
    }).join("");
    return html;
  }

  // Deliberately NOT the orange flag chip that artificial ingredients get.
  // The claim here is only that a well-known laxative ingredient is present,
  // which is a fact about the ingredient list — not that the product is a
  // laxative, and a warning-coloured chip would read as the second. Plain
  // text, with the "what this does and does not mean" explanation carried by
  // the row's own "?" rather than repeated in every cell.
  function fmtLaxative(v) {
    var s = (v || "").trim();
    if (!s) return '<span class="plyt-sbs__no">—</span>';
    if (s.toLowerCase() === "none") return '<span class="plyt-sbs__cell-val">None</span>';
    return fmtList(s);
  }

  // The glossary snippet may not have run yet — Shopify gives no ordering
  // guarantee about the order its bundled scripts run in. Wire now if it's up, and
  // otherwise once more after load. wireTermTriggers is idempotent, so a
  // double call is harmless.
  function wireGlossary(el) {
    if (window.PurelyteSaltGlossary) {
      window.PurelyteSaltGlossary.wireTermTriggers(el);
      return;
    }
    window.addEventListener("load", function () {
      if (window.PurelyteSaltGlossary) window.PurelyteSaltGlossary.wireTermTriggers(el);
    });
  }

  var ROWS = [
    { key: "format", label: "Format", render: function (b) { return '<span class="plyt-sbs__cell-val">' + b.format + "</span>"; } },
    { key: "serveSize", label: 'Serve size <span class="plyt-term__wrap"><button class="plyt-term__trigger" type="button" data-term="serve-size" aria-expanded="false">?</button></span>', render: function (b) { return fmtServe(b.serveSizeMl); } },
    { key: "sodium", label: "Sodium", render: function (b) { return fmtMg(b.sodium, b.sodiumSource, "sodium", b.sodiumNote); } },
    { key: "potassium", label: "Potassium", render: function (b) { return fmtMg(b.potassium, b.potassiumSource, "potassium"); } },
    { key: "magnesium", label: "Magnesium", render: function (b) { return fmtMg(b.magnesium, b.magnesiumSource, "magnesium"); } },
    { key: "calcium", label: "Calcium", render: function (b) { return fmtMg(b.calcium, b.calciumSource, "calcium"); } },
    { key: "sugar", label: "Sugar / high-GI carbs", render: function (b) { return fmtSugar(b); } },
    { key: "sweetener", label: "Sweetener", render: function (b) { return fmtList(b.sweetener); } },
    { key: "artificial", label: "Artificial ingredients", render: function (b) { return fmtArtificial(b.artificialIngredients); } },
    { key: "laxative", label: 'Laxative-effect ingredients <span class="plyt-term__wrap"><button class="plyt-term__trigger" type="button" data-term="laxative-ingredients" aria-expanded="false">?</button></span>', render: function (b) { return fmtLaxative(b.laxativeIngredients); } },
    { key: "maltodextrin", label: 'Maltodextrin <span class="plyt-term__wrap"><button class="plyt-term__trigger" type="button" data-term="maltodextrin" aria-expanded="false">?</button></span>', render: function (b) { return fmtMaltodextrin(b.maltodextrin, b.maltodextrinNote); } },
    // Label deliberately short. "Batch tested, banned substances" paired with a
    // Yes/No cell read as "Yes — banned substances", the opposite of the claim.
    { key: "batchTested", label: "Batch tested", render: function (b) { return fmtBool(b.batchTested); } },
    { key: "servings", label: "Servings per pack", render: function (b) { return '<span class="plyt-sbs__cell-val">' + b.servingsPerPack + "</span>"; } },
    { key: "pricePerServe", label: "Price per serve", render: function (b) { return '<span class="plyt-sbs__cell-val">$' + Number(b.pricePerServe).toFixed(2) + "</span>"; } },
    { key: "costPerLitre", label: "Cost per litre", render: function (b) { return fmtPerLitre(b); } },
    { key: "pricePer1000mg", label: 'Price per 1,000mg key electrolytes <span class="plyt-term__wrap"><button class="plyt-term__trigger" type="button" data-term="key-electrolytes" aria-expanded="false">?</button></span>', render: function (b) { return '<span class="plyt-sbs__cell-val">$' + Number(b.pricePer1000mg).toFixed(2) + "</span>"; } }
  ];

  window.PurelyteComparisonCells = {
    ROWS: ROWS,
    perLitreValue: perLitreValue,
    wireGlossary: wireGlossary
  };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["purelyte-salt-glossary"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.PurelyteSaltGlossary) return;

  var GLOSS = {
    chloride:    { term: "Chloride", body: "The mineral bound to chloride — sodium chloride is table salt, potassium chloride the usual salt substitute. Cheapest and most common across sports drinks, and well absorbed, though at higher doses chloride forms can sit heavier on the stomach than citrate or lactate." },
    citrate:     { term: "Citrate", body: "Bound to citric acid. Dissolves easily and mixes smooth — generally gentler on the gut than chloride or oxide forms, which is why it shows up often in potassium and calcium blends." },
    // Mineral-scoped override. Keys of the form <mineral>-<form> beat the
    // plain <form> entry, for cases where the same salt behaves differently
    // depending on the mineral it's carrying. Magnesium citrate is the clear
    // one: it's osmotic enough to be sold as a laxative, which is not true of
    // potassium or calcium citrate.
    "magnesium-citrate": { term: "Magnesium Citrate", body: "Bound to citric acid and well absorbed, but osmotic — it draws water into the bowel, which is why it's also sold on its own as a laxative. Whether that's noticeable depends on individual GI tolerance and on dose." },
    malate:      { term: "Malate", body: "Bound to malic acid, a compound muscles use in energy metabolism. A common magnesium form aimed at easier digestion." },
    lactate:     { term: "Lactate", body: "Bound to lactic acid. Well absorbed with a mild, neutral taste, and one of the gentler magnesium forms on the stomach — many people find it sits comfortably where citrate, oxide or sulfate don't. The form Purelyte uses for magnesium." },
    oxide:       { term: "Oxide", body: "The least expensive, least absorbable common form. A large share passes straight through undigested, which is why it's the form most often linked to a laxative effect." },
    sulfate:     { term: "Sulfate", body: "Bound to sulfate — Epsom-salt chemistry. Absorbs less efficiently than citrate or lactate and can have a mild laxative effect at higher doses." },
    gluconate:   { term: "Gluconate", body: "Bound to gluconic acid, a mild organic acid. Comparable absorption to citrate, with a very neutral taste." },
    bicarbonate: { term: "Bicarbonate", body: "Mildly alkalising. Reacts readily with acids, which is what makes it fizz in effervescent tablets — less common in still powders." },
    carbonate:   { term: "Carbonate", body: "Chemically close to bicarbonate and similarly alkalising. Common in tablet and capsule formats, less common in drink powders." },
    phosphate:   { term: "Phosphate", body: "Bound to phosphate. Used for its buffering properties in some sports-drink formulas, though generally less bioavailable than citrate or lactate forms." },
    glycinate:   { term: "Glycinate", body: "Bound to glycine, an amino acid — also sold as bisglycinate. Absorbs well and is among the gentler magnesium forms on the stomach, which is why it's common in supplements aimed at daily use." },
    aspartate:   { term: "Aspartate", body: "Bound to aspartic acid, an amino acid. Reasonably well absorbed, though less commonly used in drink mixes than citrate or glycinate." },
    hydroxide:   { term: "Hydroxide", body: "Alkalising and poorly soluble in water — the compound behind milk of magnesia. Very little is absorbed, and it's the form most associated with a laxative effect." },
    "pink-himalayan-salt": { term: "Pink Himalayan Salt", body: "Unrefined rock salt, and Purelyte's sodium source. Unlike highly processed table salt, it naturally contains 84 trace minerals, which give it its soft pink colour." },
    maltodextrin: { term: "Maltodextrin", body: "A starch-derived carbohydrate, usually from corn, used to carry flavours or add bulk. It's high-GI — higher than table sugar — so it can add a carbohydrate load even in small amounts. Most powdered flavours, natural and artificial alike, are dried onto maltodextrin as their carrier, so a powder listing a flavour and naming no carrier very likely contains some. Yes means the label declares it. Likely means the label lists a flavour or a coconut water powder and names no carrier — probable, but not something the label confirms. Purelyte carries none." },
    "key-electrolytes": { term: "Price per 1,000mg key electrolytes", body: "Counts sodium, potassium, magnesium and calcium. Price per serve divided by those four, scaled to 1,000mg — so a cheap but mineral-light serve can't look better than it is." },
    "serve-size": { term: "Serve size", body: "Up to serving size — the largest volume of water one serve is meant to make. Mixing into less just makes a stronger drink; the minerals listed above are per serve either way." },
    "laxative-ingredients": { term: "Laxative-effect ingredients", body: "A few ingredients used in electrolyte drinks are also used, on their own, as laxatives — magnesium citrate, oxide and sulfate all draw water into the bowel, and sugar alcohols such as sorbitol and isomalt do the same. This row names them where a label lists them. It does not mean the product is a laxative, as the effect depends on individual GI tolerance and builds with dose. It's worth knowing about if you drink several serves in a day, or if you've ever had a hydration drink not sit well." }
  };

  function closeAllTerms() {
    document.querySelectorAll(".plyt-term__trigger").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    document.querySelectorAll(".plyt-term__pop").forEach(function (p) {
      p.hidden = true;
      // A popover moved to <body> outlives its trigger if the table re-renders
      // or the section is replaced. Drop the orphans so they can't pile up.
      if (p.parentNode === document.body && p.plytTrigger && !document.contains(p.plytTrigger)) {
        p.remove();
      }
    });
  }

  // The popover is position:fixed, so it has to be placed from the trigger's
  // rect each time it opens: centred on the trigger, clamped inside the
  // viewport, flipped below when there's no room above. The arrow keeps
  // pointing at the trigger via --plyt-term-arrow even after clamping.
  function positionPop(btn, pop) {
    var margin = 8;
    var gap = 10;
    var r = btn.getBoundingClientRect();
    var pw = pop.offsetWidth;
    var ph = pop.offsetHeight;

    var left = r.left + r.width / 2 - pw / 2;
    left = Math.max(margin, Math.min(left, window.innerWidth - pw - margin));

    var below = false;
    var top = r.top - ph - gap;
    if (top < margin) {
      top = r.bottom + gap;
      below = true;
    }

    pop.style.left = Math.round(left) + "px";
    pop.style.top = Math.round(top) + "px";
    pop.style.setProperty("--plyt-term-arrow", Math.round(r.left + r.width / 2 - left) + "px");
    if (below) {
      pop.classList.add("plyt-term__pop--below");
    } else {
      pop.classList.remove("plyt-term__pop--below");
    }
  }

  function wireTermTriggers(root) {
    root = root || document;
    root.querySelectorAll(".plyt-term__trigger[data-term]").forEach(function (btn) {
      if (btn.dataset.wired) return;
      var key = btn.getAttribute("data-term");
      var entry = key ? GLOSS[key] : null;

      // Callers emit mineral-scoped keys like "magnesium-citrate" without
      // knowing whether an override exists — they can't check this glossary
      // at render time, since load order isn't guaranteed. Fall back to the
      // plain form after the first dash: magnesium-citrate -> citrate.
      if (!entry && key && key.indexOf("-") !== -1) {
        entry = GLOSS[key.slice(key.indexOf("-") + 1)];
      }

      // Nothing matched at all — remove the trigger rather than leave a "?"
      // on the page that does nothing when clicked.
      if (!entry) {
        var wrap = btn.closest(".plyt-term__wrap");
        if (wrap) { wrap.remove(); } else { btn.remove(); }
        return;
      }
      var pop = document.createElement("span");
      pop.className = "plyt-term__pop";
      pop.setAttribute("role", "tooltip");
      pop.hidden = true;
      pop.innerHTML = "<b>" + entry.term + "</b>" + entry.body;
      pop.plytTrigger = btn;
      btn.insertAdjacentElement("afterend", pop);
      btn.dataset.wired = "1";
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        var open = btn.getAttribute("aria-expanded") === "true";
        closeAllTerms();
        if (!open) {
          btn.setAttribute("aria-expanded", "true");
          // Move it to <body> before showing. The trigger sits inside a table
          // cell that is position: sticky with a z-index, and that combination
          // creates a stacking context — so however high this popover's own
          // z-index is, it can only ever paint at its cell's level. Opening
          // downwards it went behind the row labels below (same z-index, later
          // in the DOM); flipping upwards it went behind the frozen header row
          // (higher z-index). At body level it competes with the page instead.
          // Position is unaffected: it's fixed and placed from the trigger's
          // own getBoundingClientRect, which doesn't care about the parent.
          if (pop.parentNode !== document.body) document.body.appendChild(pop);
          pop.hidden = false;
          positionPop(btn, pop);  // must run while visible — offsetWidth is 0 when hidden
        }
      });
    });
  }

  document.addEventListener("click", closeAllTerms);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAllTerms(); });
  // A fixed popover doesn't travel with its trigger, so any scroll would leave
  // it stranded mid-page. Capture phase catches scrolling inside the
  // comparison table too, not just the window.
  window.addEventListener("scroll", closeAllTerms, true);
  window.addEventListener("resize", closeAllTerms);

  function initStatic() { wireTermTriggers(document); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStatic);
  } else {
    initStatic();
  }
  // Sweep again after load, in case a block rendered its triggers before this
  // snippet's script ran. wireTermTriggers skips anything already wired, so
  // this only picks up what the first pass couldn't have seen.
  window.addEventListener("load", initStatic);

  // And again whenever a section is re-rendered — the theme editor and the
  // Section Rendering API both replace markup wholesale, and the triggers that
  // come back are unwired. Same idempotent sweep, so this is safe to repeat.
  document.addEventListener("shopify:section:load", initStatic);
  document.addEventListener("shopify:block:select", initStatic);

  window.PurelyteSaltGlossary = {
    terms: GLOSS,
    wireTermTriggers: wireTermTriggers,
    closeAllTerms: closeAllTerms
  };
})();
  } catch(e) { console.error(e); }
})();

})();
